import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import { Calendar, UserPlus, ArrowRight } from 'lucide-react';

import { formatWholeNumber } from '../../../../../../../core/utils/campaigns';
import KpiBar, { KpiCard } from '../../../../../../shared/designSystem/components/KpiBar';
import { formatDateOnly } from '../../../../../../shared/designSystem/utils/dateFormat';

// =============================================================================
// TopBar (V1 SignUps) — v2 KPI strip. Replaces the legacy AntD `Card` +
// `KPITitleText` / `KpiSubText` / `KpiFlightDate` chrome with the shared
// `KpiBar` + `KpiCard` primitives, mirroring `DetailsBar.js` (V1 BasketItems)
// and `TransactionsKpiBar.js`'s flight-dates pattern.
//
// Numeric computation preserved verbatim — same `getProgress` formula as
// before, same `transactions` prop (legacy name; carries the sign-ups count
// passed by `SignUpsLayout`).
// =============================================================================

const FlightDatesCard = ({ startDate, endDate, progressPercent }) => (
  <div className="campaign-overview__kpi">
    <div className="campaign-overview__kpi-head">
      <span className="campaign-overview__kpi-icon campaign-overview__kpi-icon--neutral">
        <Calendar size={16} />
      </span>
      <Tooltip
        overlayClassName="mjl-ds"
        title="Flight Dates refers to the Start & End Dates of the individual campaign"
      >
        <span className="campaign-overview__kpi-eyebrow">Flight Dates</span>
      </Tooltip>
    </div>
    <div className="campaign-overview__flight">
      <div className="campaign-overview__flight-dates">
        <span>{formatDateOnly(startDate, '—')}</span>
        <ArrowRight size={14} className="campaign-overview__flight-arrow" />
        <span>{formatDateOnly(endDate, '—')}</span>
      </div>
      <div className="campaign-overview__flight-progress">
        <div
          className="campaign-overview__flight-progress-bar"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      <div className="campaign-overview__flight-meta">
        {progressPercent}% elapsed
      </div>
    </div>
  </div>
);

const TopBar = ({ transactions, startDate, endDate }) => {
  const getProgress = () => {
    const a = moment(endDate, moment.DATETIME_LOCAL_MS);
    const b = moment(startDate, moment.DATETIME_LOCAL_MS);
    const totaldays = a.diff(b, 'days');
    const progressDays = moment().diff(moment(startDate, moment.DATETIME_LOCAL_MS), 'days');
    if (progressDays > totaldays || progressDays === totaldays) {
      return 100;
    }
    const daysleft = totaldays - progressDays;
    const daysin = totaldays - daysleft;
    const result = (daysin / totaldays) * 100;
    return Math.floor(result);
  };

  const currentposition = getProgress();

  return (
    <KpiBar>
      <FlightDatesCard
        startDate={startDate}
        endDate={endDate}
        progressPercent={currentposition}
      />
      <KpiCard
        icon={<UserPlus size={16} />}
        iconTint="emerald"
        label="Sign Ups"
        value={formatWholeNumber(transactions)}
      />
    </KpiBar>
  );
};

export default TopBar;
